var exports = {
  "d": "xa15a2ab7--96640f--refresh-button",
};

module.exports = exports;
